import React, {useEffect, useState} from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  ActivityIndicator,
  Linking,
} from "react-native";
import {Color, globalFontStyle, globalStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Header from "../../../commonComponents/Header";
import TxnCard from "../childComponents/txnCard";
import {getWalletTransactions} from "../redux/wallet.action";
import {connect, useSelector} from "react-redux";
import {countryRegion, isMobile} from "../../../utils/commonMethods";
import {REST_OF_WORLD} from "../../../utils/constants";
import {SafeAreaView} from "react-native-safe-area-context";
import {globalImport} from "../../../common/globalImports";
import {RefreshControl} from "react-native-web-refresh-control";
import {getConfig} from "../../../utils/commonredux/commonRedux.action";
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
  partnerMap,
} from "../../../utils/globalConstant";
import {useFocusEffect} from "@react-navigation/native";

const Transaction = ({
  navigation,
  isPassBookDataAvailable,
  loading,
  walletTransactionData,
  getWalletTransactions,
  onTransactionClick,
}) => {
  const [isPullToRefresh, setIsPullToRefresh] = useState(false);
  let userInfo = useSelector(({profile}) => profile?.profileData);
  const txnLimit = GlobalScreens?.TxnPage?.txnLimit || 10;
  const [load, setLoad] = useState(true);
  const [pageNum, setPageNum] = useState(
    walletTransactionData.length > 0 ? 2 : 1,
  );
  const onClick = () => {
    //alert(1);
    Linking.openURL(userInfo?.userConfig?.txnfeeRedirectLink);
  };

  useEffect(() => {
    if (!load) {
      return;
    }
    getWalletTransactions({
      limit: txnLimit,
      page: pageNum,
      oldest:
        pageNum >= 2
          ? walletTransactionData[walletTransactionData.length - 1].id
          : 0,
    });
    setLoad(false);
    setPageNum(pageNum + 1);
  }, [pageNum, load]);

  const setLoadMore = () => {
    //alert(1);
    setLoad(true);
  };

  useFocusEffect(
    React.useCallback(() => {
      if (partnerMap?.isMyMaster) {
        getWalletTransactions({limit: txnLimit, page: 1, oldest: 0});
      }
    }, []),
  );

  const PullToRefresh = () => {
    getWalletTransactions({limit: txnLimit, page: 1, oldest: 0});
  };

  const renderFooter = () => {
    return (
      <View
        style={{
          padding: 10,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}>
        {loading ? (
          <ActivityIndicator
            size="large"
            color={globalConfigurableData.loaderColor}
          />
        ) : null}
      </View>
    );
  };
  return (
    <SafeAreaView style={[globalStyle.pageContainer, {flexGrow: 1}]}>
      {isMobile() && (
        <Header
          isInternalPage={false}
          navigation={navigation}
          pageName={GlobalScreens.TxnPage.txnTitle}
          isBackgroundColor={false}
          translate={true}
          isShowBackIcon={
            GlobalScreens?.TxnPage?.isShowBackIcon === false ? false : true
          }
        />
      )}
      <View
        style={[
          isMobile()
            ? {
                paddingHorizontal: 16,
              }
            : {
                paddingVertical: 10,
                borderWidth: 0.75,
                borderColor: globalConfigurableData.borderColor,
                borderRadius: 8,
                maxHeight: 300,
              },
          globalImport.isWeb ? {flex: 1} : {marginBottom: 100},
        ]}>
        <FlatList
          data={walletTransactionData}
          renderItem={({item}) => (
            <TxnCard 
              transaction={item} 
              onTransactionClick={onTransactionClick}
            />
          )}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={
            isMobile()
              ? {paddingBottom: 100}
              : {paddingBottom: 0, paddingHorizontal: 15, paddingVertical: 15}
          }
          keyExtractor={(item, index) => index.toString()}
          bounces={false}
          onEndReachedThreshold={0.08}
          refreshing={loading}
          ListFooterComponent={renderFooter}
          onRefresh={PullToRefresh}
          refreshControl={
            isMobile() ? (
              <RefreshControl
                colors={[Color.tradexBlue]}
                refreshing={loading}
                onRefresh={PullToRefresh}
              />
            ) : null
          }
          onEndReached={
            isPassBookDataAvailable && !loading ? setLoadMore : null
          }
        />
      </View>
      {isMobile() && globalConst.partnerId === 1 && (
        <View style={styles.bottomInfo}>
          <Text style={styles.bottomText}>
            {userInfo?.userConfig?.txnFeeInfoText}
            <Text
              onPress={onClick}
              style={[styles.bottomText, {textDecorationLine: "underline"}]}>
              &nbsp;Click Here
            </Text>
          </Text>
        </View>
      )}
    </SafeAreaView>
  );
};

const mapStateToProps = ({wallet}) => ({
  loading: wallet.loading,
  errors: wallet.errors,
  walletTransactionData: wallet.walletTransactionData,
  isPassBookDataAvailable: wallet.isPassBookDataAvailable,
});

const mapDispatchToProps = {
  getWalletTransactions,
};

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);

const styles = StyleSheet.create({
  bottomInfo: {
    position: "absolute",
    bottom: 0,
    paddingHorizontal: 18,
    paddingVertical: 12,
    borderTopColor: globalConfigurableData.borderColor,
    borderTopWidth: 0.2,
    zIndex: 10,
    backgroundColor: "white",
  },
  passbookHeading: {
    ...globalFontStyle.appFontTitle,
    color: globalConfigurableData.primaryTextColor1,
    marginVertical: 20,
  },
  bottomText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.tertiaryTextColor1,
  },
});
